import { eventFormAssembly } from './facebook';
import { AbandonmentTracking } from "./form-abandonment-tracking";
import { getLocalStorageArray, getLocalStorageObject, setLocalStorageArray, maybePrefill } from "./form-helpers";

export function wpcf7Tracking() {
  const wpcf7Elm = document.querySelectorAll('.wpcf7');

  if (wpcf7Elm) {
    document.addEventListener(
      'wpcf7mailsent',
      (event) => {
        if (event.detail.inputs && event.detail.inputs.length) {
          for (let i = 0; i < event.detail.inputs.length; i++) {
            const el = event.detail.inputs[i];

            if (el.name === 'custom-event-id') {
              dataLayer.push({
                event: el.value,
              });
            }
          }
        }
      },
      false,
    );
  }
}

export function formAssemblyTracking() {
  // Only handles one FA form per page
  const faForm = document.querySelector('.wFormContainer');
  const local = window.localStorage;
  const storedEventId = local.getItem('faForm');
  const eventId = faForm?.querySelector('[title=custom-event-id]')?.value;

  // If localStorage event ID and no matching form event ID, we're no longer on the form page
  if (storedEventId && storedEventId !== eventId) {
    // If matching thank-you URL, then we're on a confirmation page, push a success event

    if (window.location.href.search(/\/(form-thank-you|puppy-raising-thank-you)/) > 0) {
      window.dataLayer.push({
        event: storedEventId,
      });

      try {
        const postData = getLocalStorageObject('faFieldValues');
        postData['eventID'] = storedEventId;
        eventFormAssembly(postData);
      } catch (e) {
        console.error(e);
      }
      setLocalStorageArray('faFieldValues', {});
    } else {
      // Otherwise, we must be on a different page, so the form has been abandoned
      const storedHistory = getLocalStorageArray('faFieldHistory');

      if (storedHistory) {
        window.dataLayer &&
          window.dataLayer.push({
            event: 'formAbandonment',
            eventCategory: 'Form Abandonment',
            formEventId: storedEventId,
            eventAction: storedHistory[storedHistory.length - 1],
            eventHistory: storedHistory,
          });

        local.removeItem('faFieldHistory');
      }
    }

    // We've finished tracking the form, so we can clear our local storage so we don't double track abandonment
    local.removeItem('faForm');
  }

  // If we have a form and event ID, lets initialise our tracking
  if (!faForm || !eventId) return;

  // Reset the form field history
  setLocalStorageArray('faFieldHistory', []);
  setLocalStorageArray('faFieldValues', {});
  // Listen to input changes
  faForm.addEventListener('input', (e) => {
    const fieldName = e.target.name;
    if (!fieldName) return;
    // Get our form's field history
    const history = getLocalStorageArray('faFieldHistory');
    // If an input has changed, lets set our form event ID to track submission or abandonment
    local.setItem('faForm', eventId);
    // Add this field to the field history list for form abandonment tracking
    if (history[history.length - 1] !== fieldName) {
      history.push(fieldName);
      setLocalStorageArray('faFieldHistory', history);
    }

    if (e.target.title && e.target.value) {
      let fieldTitle = e.target.title
        .trim()
        .replace(/:$/g, '')
        .replace(/\s/g, '-')
        .toLowerCase();
      const fieldsetLegend = e.target
        .closest('fieldset')
        ?.querySelector('legend')
        ?.textContent?.replace(/<[^>]*>?/gm, '')
        .trim()
        .toLowerCase()
        .replace(/\s/g, '-');
      if (fieldsetLegend && fieldsetLegend === 'referrer-details') {
        fieldTitle = fieldsetLegend + '-' + fieldTitle;
      }

      const formValues = getLocalStorageObject('faFieldValues');

      if (e.target.type === 'select-one') {
        const selectedOption = e.target.options[e.target.selectedIndex].text;
        formValues[fieldTitle] = selectedOption
          .toLowerCase()
          .replace(/\s/g, '-');
      } else {
        formValues[fieldTitle] = e.target.value;
      }

      setLocalStorageArray('faFieldValues', formValues);
    }
  });
}

function initAbandonmentTracking() {
  const $abandonmentTrackingTriggers = $('[name="abandonment-tracking"]');
  let $forms;

  if ($abandonmentTrackingTriggers.length > 0) {
    $forms = $abandonmentTrackingTriggers.closest('form');

    const abandonmentStorage = getLocalStorageObject('gd_abandonment_f');

    $forms.each((index, form) => {
      new AbandonmentTracking($(form));
      if (abandonmentStorage && Object.keys(abandonmentStorage).length) {
        maybePrefill(
          Object.keys(abandonmentStorage)[0],
          Object.values(abandonmentStorage)[0],
          $(form),
        );
      }
    });
  }
}

export function init() {
  wpcf7Tracking();
  formAssemblyTracking();
  initAbandonmentTracking();
  initAbandonmentTracking();
}
